export default __webpack_public_path__ + "static/media/ExcavationSiteMap.f640c038.jpg";